import { prop } from "../../decorators/property";

export class KeyParagraphSentenceModel extends Backbone.AssociatedModel {
    @prop() public RawContent: string;
    @prop() public Score: number;
    @prop() public ScoreClass: string;
    @prop() public IsPowerSentence: boolean;
    @prop() public QuoteIds: string[];

    constructor(options?) {
        super(options);
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/models/key-paragraph-sentence.ts